module.exports = __webpack_public_path__ + "img/sv25.dce7a382.svg";